var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "no-ssr-loader",
    [
      _c(
        "b-container",
        { staticClass: "py-5" },
        [
          _c(
            "b-row",
            { attrs: { "align-v": "center" } },
            [
              _c("b-col", { attrs: { cols: "8" } }, [
                _c("h1", { staticClass: "mb-3" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.isEdit ? "Edit Catalogue" : "Create New Catalogue"
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-right", attrs: { cols: "4" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-auto",
                      attrs: { to: "/catalogues/view", variant: "primary" },
                    },
                    [_vm._v("\n          View Catalogues\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("catalogue-form", {
                    attrs: { catalogueid: _vm.catalogueid },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }